import React, { useState } from 'react';
import './CollegeOrganisation.css';
import OrientationSession from '../OrientationSession/OrientationSession';
import ExpertTalk from '../ExpertTalk/ExpertTalk';
import FDPDetail from '../FDPDetail/FDPDetail';

const TABS = [
  { key: 'workshop',       label: 'Workshop',           sub: 'Regular & Advanced' },
  { key: 'specialisation', label: 'Value Added Courses', sub: 'Specialisation' },
  { key: 'event',          label: 'Single Day Event',    sub: 'Orientation' },
  { key: 'expert',         label: 'Expert Talk',         sub: 'Guest Lecture' },
  { key: 'fdp',            label: 'FDP',                 sub: 'Faculty Development' },
];

const WORKSHOP_SUBTABS = [
  { key: 'regular',  label: 'Regular (Embedded, IoT)' },
  { key: 'advanced', label: 'Advanced (Drone, Mechatronics, AI+RPI)' },
];

function CollegeOrganisation({ onClose, onMoreDetails, onCloseTraining }) {
  const [activeTab,       setActiveTab]       = useState('workshop');
  const [activeSubTab,    setActiveSubTab]    = useState('regular');
  const [showEnquiry,     setShowEnquiry]     = useState(false);
  const [showOrientation, setShowOrientation] = useState(false);
  const [showExpertTalk,  setShowExpertTalk]  = useState(false);
  const [showFDPDetail,   setShowFDPDetail]   = useState(false);
  const [formData, setFormData] = useState({
    collegeName: '', contactPerson: '', phone: '',
    email: '', city: '', studentCount: '',
    programme: '', customProgramme: '', message: '',
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = () => { alert('Enquiry submitted! Our team will contact you within 24 hours.'); setShowEnquiry(false); };

  const LogisticsNote = () => (
    <div style={{ background:'#f9fafc', border:'1px solid #e0e0e0', borderRadius:'8px', padding:'14px 16px', display:'flex', gap:'12px', alignItems:'flex-start' }}>
      <span style={{ fontSize:'20px' }}>✈️</span>
      <div>
        <p style={{ fontSize:'12px', fontWeight:'800', color:'#333', marginBottom:'4px', letterSpacing:'0.5px' }}>IMPORTANT — LOGISTICS POLICY</p>
        <p style={{ fontSize:'13px', color:'#555', lineHeight:'1.6' }}>
          Travel and accommodation expenses for the ibots trainer/speaker shall be arranged and borne by the organising institution.
        </p>
      </div>
    </div>
  );

  return (
    <div className="co__wrapper">
      <div className="co__inner">

        <button className="co__close" onClick={onClose}>✕</button>

        <div className="co__header">
          <div>
            <h2 className="co__title">College Organisation Training</h2>
            <p className="co__subtitle">
              iBots trainers conduct on-campus workshops, specialisation
              programs, orientation sessions & expert guest lectures for
              students and faculty.
            </p>
          </div>
          <button className="co__trainers-btn" onClick={() => setShowEnquiry(true)}>
            Trainers Come to Your Campus
          </button>
        </div>

        <div className="co__info-box">
          <span className="co__info-icon">🚌</span>
          <div>
            <p className="co__info-title">ibots Trainers Visit Your College Campus — No Student Commute Needed</p>
            <p className="co__info-desc">
              Our team arrives with all equipment and hardware. Minimum 60 students per batch.
              Fully customisable curriculum. Progress reports and certificates provided for every student.
            </p>
          </div>
        </div>

        <div className="co__badges">
          {[
            { text: 'Ratio:  60:1' },
            { text: 'Mode: Offline (at your campus)' },
            { text: 'Certificates Provided' },
            { text: 'Min 60 Students per Batch' },
          ].map((b, i) => (
            <span key={i} className="co__badge"><span>{b.icon}</span> {b.text}</span>
          ))}
        </div>

        <div className="co__tabs">
          {TABS.map((tab) => (
            <button key={tab.key}
              className={`co__tab ${activeTab === tab.key ? 'co__tab--active' : ''}`}
              onClick={() => { setActiveTab(tab.key); onCloseTraining && onCloseTraining(); }}>
              <span className="co__tab-label">{tab.label}</span>
              <span className="co__tab-sub">{tab.sub}</span>
            </button>
          ))}
        </div>

        {activeTab === 'workshop' && (
          <div className="co__subtabs">
            {WORKSHOP_SUBTABS.map((sub) => (
              <button key={sub.key}
                className={`co__subtab ${activeSubTab === sub.key ? 'co__subtab--active' : ''}`}
                onClick={() => { setActiveSubTab(sub.key); onCloseTraining && onCloseTraining(); }}>
                {activeSubTab === sub.key && <span className="co__subtab-dot" />}
                {sub.label}
              </button>
            ))}
          </div>
        )}

        {/* Regular Workshop */}
        {activeTab === 'workshop' && activeSubTab === 'regular' && (
          <div className="co__cards">
            <div className="co__card">
              <div className="co__card-header">
                <span className="co__card-tag">FOUNDATIONAL</span>
                <span className="co__card-badge">Campus Visit</span>
              </div>
              <div className="co__card-body">
                <h3 className="co__card-title">Regular Workshop – Embedded & IoT</h3>
                <div className="co__card-tags">
                  {['3–5 Days', '30 Hours', '(6 Hours/Day)', '60 Students'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Team activities, mini-project building & live demonstrations</li>
                  <li>Hands-on training designed to build strong fundamentals in core engineering technologies and practical applications.</li>
                  <li>Creates awareness on the importance of practical learning and industry skills for career growth</li>
                  <li>Ideal for 1st & 2nd Year Engineering Students</li>
                </ul>
                <button className="co__card-btn" onClick={() => onMoreDetails && onMoreDetails('workshop')}>→ More Details</button>
              </div>
            </div>

            <div className="co__card co__card--custom">
              <div className="co__card-header co__card-header--custom">
                <span className="co__card-tag">WORKSHOP · CUSTOMISED</span>
                <span className="co__card-badge">Custom Build</span>
              </div>
              <div className="co__card-body">
                <div className="co__card-title-row">
                  <h3 className="co__card-title">Customised Regular Workshop</h3>
                  <span className="co__flexible-badge">Flexible</span>
                </div>
                <div className="co__card-tags">
                  {['Custom duration', 'Flexible hrs', 'Pick your topics', 'Min 60'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Every institution has unique training requirements and academic goals</li>
                  <li>Customise your workshop by selecting specific domains such as Electronics, Embedded Systems, IoT & Robotics</li>
                  <li>Flexible session duration, training hours and module structure based on your requirements</li>
                  <li>Training modules can be aligned with department curriculum, technical events or specialisation programs</li>
                </ul>
                <button className="co__card-btn" onClick={() => setShowEnquiry(true)}>Request Custom Workshop →</button>
              </div>
            </div>
          </div>
        )}

        {/* Advanced Workshop */}
        {activeTab === 'workshop' && activeSubTab === 'advanced' && (
          <div className="co__cards">
            <div className="co__card">
              <div className="co__card-header">
                <span className="co__card-tag">ADVANCED LEVEL</span>
                <span className="co__card-badge">Campus Visit</span>
              </div>
              <div className="co__card-body">
                <h3 className="co__card-title">Advanced Workshop – Drone & Mechatronics</h3>
                <div className="co__card-tags">
                  {['3–5 Days', '30 Hours', '(6 Hours/Day)', '60 Students'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Hands-on sessions on Drone Assembly, Mechatronics & AI with Raspberry Pi</li>
                  <li>Advanced project building with real hardware and live demonstrations</li>
                  <li>Ideal for 3rd & 4th Year Engineering Students</li>
                </ul>
                <button className="co__card-btn" onClick={() => onMoreDetails && onMoreDetails('advanced_workshop')}>→ More Details</button>
              </div>
            </div>

            <div className="co__card co__card--custom">
              <div className="co__card-header co__card-header--custom">
                <span className="co__card-tag">WORKSHOP · CUSTOMISED</span>
                <span className="co__card-badge">Custom Build</span>
              </div>
              <div className="co__card-body">
                <div className="co__card-title-row">
                  <h3 className="co__card-title">Customised Advanced Workshop</h3>
                  <span className="co__flexible-badge">Flexible</span>
                </div>
                <div className="co__card-tags">
                  {['Custom duration', 'Flexible hrs', 'Pick your topics', 'Min 60'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Choose from Drone, Mechatronics, AI+RPI or any combination</li>
                  <li>Fully customisable based on department needs and academic goals</li>
                  <li>Pricing finalized after reviewing scope and selected modules</li>
                </ul>
                <button className="co__card-btn" onClick={() => setShowEnquiry(true)}>Request Custom Workshop →</button>
              </div>
            </div>
          </div>
        )}

        {/* Value Added Courses */}
        {activeTab === 'specialisation' && (
          <div className="co__cards">
            <div className="co__card" style={{ gridColumn:'1 / -1' }}>
              <div className="co__card-header">
                <span className="co__card-tag">VALUE ADDED COURSES · ONGOING</span>
                <span className="co__card-badge">Semester-long</span>
              </div>
              <div className="co__card-body">
                <h3 className="co__card-title">Value Added Courses</h3>
                <div className="co__card-tags">
                  {['Custom timeline', '30 hrs', '1–2 hrs/day', 'Min 60'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Semester-long industry-focused skill development programs</li>
                  <li>Placement-oriented training with hands-on practical learning</li>
                  <li>Promotes innovation culture, problem-solving skills and to build innovative real-time projects and prototypes</li>
                  <li>Customised domains and training modules based on institutional requirements</li>
                  <li>Regular assessments, assignments & progress reports shared with the institution</li>
                </ul>
                <button className="co__card-btn" onClick={() => onMoreDetails && onMoreDetails('vac')}>More Details →</button>
              </div>
            </div>
          </div>
        )}

        {/* Orientation Session */}
        {activeTab === 'event' && (
          <div className="co__cards">
            <div className="co__card" style={{ gridColumn:'1 / -1' }}>
              <div className="co__card-header">
                <span className="co__card-tag">ORIENTATION · HANDS-ON TRAINING</span>
                <span className="co__card-badge">One Day</span>
              </div>
              <div className="co__card-body">
                <div style={{ display:'flex', justifyContent:'flex-end', marginTop:'-8px' }}>
                  <span style={{ background:'#b45309', color:'#fff', fontSize:'11px', fontWeight:'800', padding:'4px 12px', borderRadius:'4px', letterSpacing:'0.5px', textTransform:'uppercase' }}>
                    HANDS-ON TRAINING INCLUDED
                  </span>
                </div>
                <h3 className="co__card-title">Orientation Session</h3>
                <div className="co__card-tags">
                  {['6 hrs session', 'Any batch size', 'Your campus'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Structured full-day program with progressive learning flow</li>
                  <li>Introduction to the selected technology domain</li>
                  <li>Expert technical session covering core concepts & real-world applications</li>
                  <li>Live hands-on training with hardware, tools & mini project development</li>
                  <li>Focus on practical exposure, skill understanding & industry relevance</li>
                  <li>Ideal for department inductions, technical events & college tech days</li>
                </ul>
                <LogisticsNote />
                <button className="co__card-btn" onClick={() => setShowOrientation(true)}>More Details →</button>
              </div>
            </div>
          </div>
        )}

        {/* Expert Talk */}
        {activeTab === 'expert' && (
          <div className="co__cards">
            <div className="co__card" style={{ gridColumn:'1 / -1' }}>
              <div className="co__card-header">
                <span className="co__card-tag">EXPERT TALK</span>
                <span className="co__card-badge">Half Day</span>
              </div>
              <div className="co__card-body">
                <h3 className="co__card-title">Guest Lecture</h3>
                <div className="co__card-tags">
                  {['1–2 hrs', 'Any batch size', 'Your campus'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Expert industry talk on AI, Robotics, Drones, IoT & Electronics</li>
                  <li>Real-world applications, innovation trends & career insights</li>
                  <li>Career guidance for students on emerging technology fields</li>
                  <li>Interactive discussion, Q&A and student engagement session</li>
                </ul>
                <LogisticsNote />
                <button className="co__card-btn" onClick={() => setShowExpertTalk(true)}>More Details →</button>
              </div>
            </div>
          </div>
        )}

        {/* FDP */}
        {activeTab === 'fdp' && (
          <div className="co__cards">
            <div className="co__card" style={{ gridColumn:'1 / -1' }}>
              <div className="co__card-header">
                <span className="co__card-tag">FACULTY DEVELOPMENT PROGRAMME</span>
                <span className="co__card-badge">Multi-Day</span>
              </div>
              <div className="co__card-body">
                <h3 className="co__card-title">Faculty Development Programme (FDP)</h3>
                <div className="co__card-tags">
                  {['1–5 days', 'Any batch size', 'Your campus'].map((t, i) => <span key={i} className="co__tag">{t}</span>)}
                </div>
                <ul className="co__card-points">
                  <li>Structured upskilling program for faculty in Embedded Systems, IoT, Robotics, 3D Printing</li>
                  <li>Hands-on training with real hardware, tools & practical demonstrations</li>
                  <li>Focus on improving teaching methodology through applied learning and project-based approach</li>
                  <li>Industry-relevant skill enhancement for academic delivery and student mentoring</li>
                  <li>Certification provided for all participants upon completion</li>
                </ul>
                <LogisticsNote />
                <button className="co__card-btn" onClick={() => setShowFDPDetail(true)}>More Details →</button>
              </div>
            </div>
          </div>
        )}

      </div>

      {/* Enquiry Popup */}
      {showEnquiry && (
        <div className="co__overlay" onClick={() => setShowEnquiry(false)}>
          <div className="co__form-box" onClick={(e) => e.stopPropagation()}>
            <button className="co__form-close" onClick={() => setShowEnquiry(false)}>✕</button>
            <h2 className="co__form-title">College Campus Visit — Enquiry Form</h2>
            <p className="co__form-subtitle">Fill in your details and our team will contact you within 24 hours.</p>
            <div className="co__form">
              <div className="co__form-row">
                <div className="co__form-group">
                  <label className="co__form-label">College Name *</label>
                  <input type="text" name="collegeName" value={formData.collegeName} onChange={handleChange} placeholder="Enter college name" className="co__form-input" />
                </div>
                <div className="co__form-group">
                  <label className="co__form-label">Contact Person *</label>
                  <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} placeholder="HOD / Coordinator name" className="co__form-input" />
                </div>
              </div>
              <div className="co__form-row">
                <div className="co__form-group">
                  <label className="co__form-label">Phone Number *</label>
                  <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="co__form-input" />
                </div>
                <div className="co__form-group">
                  <label className="co__form-label">Email Address *</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@college.com" className="co__form-input" />
                </div>
              </div>
              <div className="co__form-row">
                <div className="co__form-group">
                  <label className="co__form-label">City</label>
                  <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="e.g. Coimbatore" className="co__form-input" />
                </div>
                <div className="co__form-group">
                  <label className="co__form-label">Approximate Student Count</label>
                  <input type="text" name="studentCount" value={formData.studentCount} onChange={handleChange} placeholder="e.g. 60 students" className="co__form-input" />
                </div>
              </div>
              <div className="co__form-group co__form-group--full">
                <label className="co__form-label">Programme Type</label>
                <select name="programme" value={formData.programme} onChange={handleChange} className="co__form-input co__form-select">
                  <option value="">Select...</option>
                  <option value="workshop-regular">Regular Workshop (Embedded & IoT)</option>
                  <option value="workshop-advanced">Advanced Workshop (Drone, Mechatronics, AI+RPI)</option>
                  <option value="workshop-custom">Customised Workshop</option>
                  <option value="specialisation">Value Added Courses</option>
                  <option value="event">Single Day Event / Orientation</option>
                  <option value="expert">Expert Talk / Guest Lecture</option>
                  <option value="fdp">FDP (Faculty Development Programme)</option>
                  <option value="other">Other (specify below)</option>
                </select>
                {formData.programme === 'other' && (
                  <input type="text" name="customProgramme" value={formData.customProgramme} onChange={handleChange} placeholder="Describe your requirement..." className="co__form-input co__form-input--mt" />
                )}
              </div>
              <div className="co__form-group co__form-group--full">
                <label className="co__form-label">Message / Requirements</label>
                <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Any specific requirements, preferred dates, or questions..." className="co__form-input co__form-textarea" />
              </div>
              <button className="co__form-submit" onClick={handleSubmit}>Submit Enquiry →</button>
            </div>
          </div>
        </div>
      )}

      {showOrientation && <OrientationSession onClose={() => setShowOrientation(false)} />}
      {showExpertTalk  && <ExpertTalk onClose={() => setShowExpertTalk(false)} />}
      {showFDPDetail   && <FDPDetail onClose={() => setShowFDPDetail(false)} />}

    </div>
  );
}

export default CollegeOrganisation;
